import { Box, Typography, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import styles from './index.module.css'
import { FilterData } from '../../../interfaces/course'
import { transformString } from '../../../helpers/utils'
import FilterResetButton from '../../buttons/FilterResetButton'

const CLOSE_IMAGE_URL = "https://members.performancegolf.com/wp-content/uploads/2025/04/close-circle-1.svg"
const BLACK_FILTER_IMAGE = 'https://members.performancegolf.com/wp-content/uploads/2025/04/filterBlack-1.svg' //old black filter
const FILTER_IMAGE = 'https://members.performancegolf.com/wp-content/uploads/2025/12/filter-black-icon.svg'

interface Props {
    handleMobileFilterToggle: ()=> void
    selectedFilters: Record<string, string[]>
    filterData: FilterData[];
    onFilterChange: (filterType: string, category: string) => void,
    handleResetFilter: () => void;
    source?: string
}

function HeaderTrainingMobile({handleMobileFilterToggle,selectedFilters, filterData, onFilterChange, handleResetFilter, source}:Props) {
useEffect(() => {
    if (filterData.length > 0) {
        setLocalFilterData(filterData);
    }
}, [filterData]);
  const theme = useTheme();
  const [localFilterData, setLocalFilterData] = useState<FilterData[]>([]);

  const allowedCourseTypes = ["irons", "driving", "bunkers", "chipping", "putting", "mental-game"];

  console.log("selected on mob is >> ", selectedFilters)

  
//count for filter number
const courseTypeCount = useMemo(() => {
    return Object.values(selectedFilters).reduce((acc, arr) => acc + arr.length, 0);
  }, [selectedFilters]);

  const filtersAreActive = useMemo(() => {
    return Object.keys(selectedFilters).some(key => Array.isArray(selectedFilters[key]) && selectedFilters[key].length > 0);
  }, [selectedFilters]);
  
  return (
    <Box sx={{ fontFamily: "'Repro', sans-serif" }}>
    <Box display={'flex'} flexDirection={'row'} marginTop={'25px'} maxHeight={'43px'} sx={{justifyContent: source !== "Training" ? "end" : "start"}}>
        <Box display={'flex'} flexDirection={'column'}>
            <Box display={'flex'} justifyContent={'flex-end'} marginRight={'13px'} sx={{gap: '12px'}}>
                { filtersAreActive && source !== "Training"? <FilterResetButton handleResetFilter={handleResetFilter} width={"80px"}/> : null}
                <Box onClick={handleMobileFilterToggle} className={source !== "Training"? styles.filterContainerBlack : styles.filterContainer } sx={{display:'flex',justifyContent:'center',alignItems:'center',cursor:'pointer'}}>
                    {filtersAreActive && 
                    <Box sx={{ display: source !== "Training"? 'block' :'none',width:'12px', height:'12px', borderRadius:'50%', backgroundColor:'#355ADD' , position:'absolute', top:'-4px', right:'-4px'}}/>}
                    <img src={ source !== "Training" ?BLACK_FILTER_IMAGE :FILTER_IMAGE} alt='' style={{maxWidth:'none'}}/>
                    {source === "Training" &&
                    <Typography variant="body2" sx={{ marginLeft: '12px', fontWeight: 600 }}>
                        ({courseTypeCount})
                    </Typography>
                    }
                </Box>
                {source === "Training" &&
                <Box
                    sx={{
                    borderLeft: '1px solid #7B726C',
                    height: '41px', 
                    }}
                />
        }
                </Box>
            <Box display={'flex'} justifyContent={'flex-start'} sx={{
                [theme.breakpoints.down(900)]: {
                    display: "none"
                }
            }}>

            </Box>
        </Box>
        <Box
            sx={{
                maxHeight: '43px',
                overflowX: 'auto',
                display: 'flex',
                flexDirection: 'row',
                gap: '12px',
            }}
            >
            {localFilterData
            .filter(filter => filter.filterType === "Course Type") // Only include "Course Type"
            .map(filter =>
                filter.data
                    .filter(el => allowedCourseTypes.includes(el.category)) // Filter only allowed course types
                    .map(el => {
                const isSelected = selectedFilters[filter.filterType]?.includes(el.category);
                return (
                    <Box
                    onClick={() => {
                        // onFilterChange(filter.filterType, el.category, isSelected ? false : true);
                        
                        onFilterChange(filter.filterType, el.category);
                    
                    }}
                    key={`${filter.filterType}-${el.category}`}
                    className={styles.filterBox}
                    sx={{
                        padding: '12px',
                        backgroundColor: isSelected ? '#FD3300' : 'transparent',
                    }}
                    >
                    <Box
                        sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexGrow: 1,
                        }}
                    >
                        <Typography
                        sx={{ whiteSpace: 'nowrap', textTransform: 'uppercase' }}
                        fontSize={16}
                        fontWeight={400}
                        color= {isSelected? "#fff" : "#1D1A1A"}
                        overflow= 'hidden'
                        >
                        {transformString(el.title)}
                        </Typography>
                        {isSelected && <img src={CLOSE_IMAGE_URL} style={{marginLeft:'8px'}} alt="Remove Filter" />}
                    </Box>  
                    </Box>
                );
                })
            )}
        </Box>
    </Box>
    </Box>
  )
}

export default HeaderTrainingMobile